import type { SVGProps } from "react";
const SvgNginx = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#009639"
      d="M27.645 186.044c1.057 1.872 2.584 3.277 4.464 4.33l90.458 51.959c3.76 2.223 8.341 2.223 11.983 0l90.459-51.959c3.759-2.106 5.991-6.085 5.991-10.415V76.042c0-4.33-2.232-8.309-5.991-10.415l-90.459-51.96c-3.759-2.223-8.341-2.223-11.983 0L32.11 65.628C28.232 67.733 26 71.712 26 76.042v104.033c0 2.108.47 4.097 1.645 5.969"
    />
    <path
      fill="#fff"
      d="M100.163 168.346a11.7 11.7 0 0 1-.869 4.467 11.6 11.6 0 0 1-2.509 3.788A11.486 11.486 0 0 1 88.581 180a11.49 11.49 0 0 1-8.203-3.399 11.6 11.6 0 0 1-2.51-3.788 11.7 11.7 0 0 1-.868-4.467V88.419c0-6.24 5.498-11.301 13.102-11.301 5.499 0 11.933 2.236 15.794 7.063l3.508 4.238 48.433 58.267V88.654c0-6.475 5.148-11.654 11.582-11.654S181 82.18 181 88.654v79.928c0 6.238-5.498 11.3-13.102 11.3-5.499 0-11.933-2.236-15.793-7.063l-51.942-62.388z"
    />
  </svg>
);
export default SvgNginx;
